module.exports = __webpack_public_path__ + "ford.svg";